import { appApiSlice } from "src/api/app-ApiSlice";
import { TAG_USER_CUSTOM_ITEMS } from "src/api/api-tags";

export interface UserCustomIcon {
    color: string;
    icon_svg: string;
    id: number;
}

export type UserCustomIconList = UserCustomIcon[];

export interface AddUserCustomItemRequest {
    product_name: string;
    article_number: string;
    icon_id: number;
    icon_color: string;
    price_huf: number;
    price_eur: number;
    price_gbp: number;
    price_czk: number;
    price_usd: number;
    price_pln: number;
    price_chf: number;
    quote_image_url?: string;
    details?: string;
    internal_product_manufacturer_id: number | null | undefined;
    user_manufacturer_id: number | null | undefined;
    is_auto_exchange: number;
    comment?: string;
}

export interface UpdateUserCustomItemRequest {
    icon_color: string;
    product_name: string;
    user_custom_item_id: number;
    icon_id: number;
    comment?: string;
    quote_image_url?: string;
    details?: string;
    internal_product_manufacturer_id: number | null | undefined;
    user_manufacturer_id: number | null | undefined;
    is_auto_exchange: number;
    article_number: string;
    price_usd: number,
    price_eur: number,
    price_gbp: number,
    price_huf: number,
    price_czk: number,
    price_pln: number,
    price_chf: number,
}

export interface AddUserCustomItemResponse {
    status: string;
    message: string;
    id: number;
    new_icon_id: number;
}

export const userCustomItemsApiSlice = appApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getIcons: builder.query<UserCustomIconList, void>({
            query() {
                return `v1/user-custom-items/get-icons`
            },
        }),
        addUserCustomItem: builder.mutation<AddUserCustomItemResponse, AddUserCustomItemRequest>({
            query: (body) => ({
                url: "v1/user-custom-items/user-custom-item",
                method: "POST",
                body,
            }),
            invalidatesTags: [TAG_USER_CUSTOM_ITEMS],
        }),
        deleteMyProduct: builder.mutation<void, { user_custom_item_id: number }>({
            query: (body) => ({
                url: "v1/user-custom-items/user-custom-item",
                method: "DELETE",
                body,
            }),
            invalidatesTags: [TAG_USER_CUSTOM_ITEMS],
        }),
        updateMyProduct: builder.mutation<void, UpdateUserCustomItemRequest>({
            query: (body) => ({
                url: "v1/user-custom-items/user-custom-item",
                method: "PUT",
                body,
            }),
            invalidatesTags: [TAG_USER_CUSTOM_ITEMS],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetIconsQuery,
    useAddUserCustomItemMutation,
    useDeleteMyProductMutation,
    useUpdateMyProductMutation
} = userCustomItemsApiSlice;